module.exports = __webpack_public_path__ + "img/photo-1.8728bbbc.jpg";